module.exports = __webpack_public_path__ + "images/e774f59f009c7f70428d815f90dece36.svg";